import React from 'react'

import './LiveNow.scss'

const LiveNow = () => <span className="live-now">Live now</span>

export default LiveNow
